import Vue from 'vue'
import Router from 'vue-router'
import mainContainer from '@/components/mainContainer'
import decadeComponent from '@/components/decadeComponent.vue'
import yearComponent from '@/components/yearComponent.vue'
import pageNotFound from '@/components/pageNotFound'
import books from '@/components/books'
import contactUs from '@/components/contactUs'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'mainContainer',
      component: mainContainer
    },
    {
      path: '/books',
      name: 'books',
      component: books
    },
    {
      path: '/:decade(1980|1990|2000|2010|2020)', // Validates that the decade must be 2000, 2010, or 2020
      name: 'decade',
      component: decadeComponent,
      props: route => ({ decade: parseInt(route.params.decade, 10) }),
    },
    {
      path: '/:decade/:year',
  name: 'year-detail',
  component: yearComponent,
  props: route => {
    const year = parseInt(route.params.year, 10);
    const decade = parseInt(route.params.decade, 10);

    // Validate decade and year range
    if (
      (decade === 1980 && year >= 1980 && year <= 1989) ||
      (decade === 1990 && year >= 1990 && year <= 1999) ||
      (decade === 2000 && year >= 2000 && year <= 2009) ||
      (decade === 2010 && year >= 2010 && year <= 2019) ||
      (decade === 2020 && year >= 2020 && year <= 2029)
    ) {
      return { year };
    }

    // Return null if invalid, triggering a 404 or fallback
    return { year: null };
  },
  beforeEnter: (to, from, next) => {
    const year = parseInt(to.params.year, 10);
    const decade = parseInt(to.params.decade, 10);

    if (
      (decade === 1980 && year >= 1980 && year <= 1989) ||
      (decade === 1990 && year >= 1990 && year <= 1999) ||
      (decade === 2000 && year >= 2000 && year <= 2009) ||
      (decade === 2010 && year >= 2010 && year <= 2019) ||
      (decade === 2020 && year >= 2020 && year <= 2029)
    ) {
      next();
    } else {
      next({ name: 'pageNotFound' }); // Redirect to 404
    }
  },
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: contactUs
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: pageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js